import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './pages/ProtectedRoute';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import ParticipantsList from './pages/ParticipantsList';
import ParticipantForm from './pages/ParticipantForm';
import ParticipantDetail from './pages/ParticipantDetail';
import RoomsList from './pages/RoomsList';
import RoomForm from './pages/RoomForm';
import RoomDetail from './pages/RoomDetail';
import AdminUsersPage from './pages/AdminUsersPage';
import DomainsList from './pages/DomainsList';
import DomainForm from './pages/DomainForm';
import DevicesList from './pages/DevicesList';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1565c0' },
    secondary: { main: '#ff9800' },
  },
});

function ProtectedLayout() {
  return (
    <div>
      <Navbar />
      <Container sx={{ mt: 3 }}>
        <Outlet />
      </Container>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={
            <ProtectedRoute>
              <ProtectedLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="participants" element={<ParticipantsList />} />
            <Route path="participants/new" element={<ParticipantForm />} />
            <Route path="participants/:id" element={<ParticipantDetail />} />
            <Route path="participants/:id/edit" element={<ParticipantForm />} />
            <Route path="rooms" element={<RoomsList />} />
            <Route path="rooms/new" element={<RoomForm />} />
            <Route path="rooms/:id" element={<RoomDetail />} />
            <Route path="rooms/:id/edit" element={<RoomForm />} />
            <Route path="domains" element={<DomainsList />} />
            <Route path="domains/new" element={<DomainForm />} />
            <Route path="domains/:id/edit" element={<DomainForm />} />
            <Route path="admins" element={<AdminUsersPage />} />
            <Route path="devices" element={<DevicesList />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
